module.exports = __webpack_public_path__ + "media/jd.93470db1.mp4";